// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/styles/app.css' // app.css
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false;

// Vue.prototype.shopCarList = [];

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js